export class RegisterRequired {
    phoneNumber: string

    constructor(phoneNumber: string) {
        this.phoneNumber = phoneNumber
    }
}